module.exports = __webpack_public_path__ + "media/images/pic/kpo-a8204b6719ddb490a7c7e363cd30386e.png";